import React from 'react';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import { ShippingOrder } from '../../DeShippingTableWrapper';

interface OverviewTabProps {
  order: ShippingOrder;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ order }) => {

  // Calculate days since order creation with color coding
  const getDateWithDays = (dateString: string) => {
    const createdDate = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - createdDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    // Format date as MM/DD/YYYY
    const formattedDate = createdDate.toLocaleDateString('en-US');
    
    // Determine color based on days
    let dayColor = '';
    if (diffDays < 2) {
      dayColor = 'text-success';
    } else if (diffDays <= 4) {
      dayColor = 'text-warning';
    } else {
      dayColor = 'text-danger';
    }
    
    return {
      formattedDate,
      diffDays,
      dayColor
    };
  };

  // Get tooltip text based on financial status
  const getFinancialStatusTooltip = (status: string) => {
    if (status.toUpperCase() === 'PAID') {
      return 'Payment has been received';
    }
    return 'Financial status information';
  };

  const dateInfo = getDateWithDays(order.created_at);

  return (
    <div className="overview-tab">
      <Tooltip target=".financial-status-badge" />
      
      <Card title="Order Details" className="mb-4">
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="mb-3">
              <strong>Order ID:</strong> {order.order_id}
            </div>
            <div className="mb-3">
              <strong>Order Name:</strong> {order.order_name}
            </div>
            <div className="mb-3">
              <strong>Created:</strong> {dateInfo.formattedDate}
              <span className={`small fw-bold ${dateInfo.dayColor} mx-2`}>
                ({dateInfo.diffDays} day{dateInfo.diffDays !== 1 ? 's' : ''} since order created)
              </span>
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="mb-3">
              <strong>Financial Status:</strong> 
              <Badge 
                value={order.financial_status} 
                className="mx-2 financial-status-badge" 
                data-pr-tooltip={getFinancialStatusTooltip(order.financial_status)}
              />
            </div>
            <div className="mb-3">
              <strong>Order Total:</strong> ${order.order_subtotal.toFixed(2)}
            </div>
            <div className="mb-3">
              <strong>Total Items:</strong> {order.total_items}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};